module.exports = __webpack_public_path__ + "img/portfolio-07-480x343.15686d19.jpg";